export const AddressLookupMatchDescriptions = {
    noClicks: "noClicks",
    goodMatch: "goodMatch",
    badMatch: "badMatch",
    matchFour: "matchFour",
    singleMatch: "Single Match",
};
